<template>
  <div>
    <div class="mb-4">
      <div class="row align-items-center justify-content-center mb-4">
        <div class="col-6 col-md-5">
          <p class="mb-0">Admit Card Preview</p>
        </div>
        <!-- Print Button -->
        <div class="col-6 col-md-5 neo-tr-5 d-print-none text-right">
          <div v-if="student">
            <button
              type="button"
              class="btn btn-light btn-sm btn-with-addon"
              @click="print"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-printer" />
              </span>
              Print
            </button>
          </div>
        </div>
      </div>
      <a-spin :spinning="false">
        <div v-if="student" id="admitCard">
          <div class="row justify-content-center mt-4">
            <div class="col-md-10 col-12 border border-dark rounded">
              <!-- Header -->
              <div class="d-flex rounded-top neo_id_school_card_header">
                <div class="col-12 px-4 pt-4 pb-1">
                  <div
                    class="d-flex align-items-center justify-content-center pb-1"
                  >
                    <div class="text-center mr-4">
                      <!-- <a-avatar :size="75" shape="square" :src="user.user.school.logo" /> -->
                      <img
                        width="70"
                        class="rounded"
                        :src="user.user.school.logo"
                      />
                    </div>
                    <div class="pl-0 neo_id_card_school_name">
                      <h5 class="mb-0">{{ user.user.school.name }}</h5>
                      <p class="mb-0">
                        {{ user.user.school.contact.address }},
                        {{ user.user.school.contact.city }},
                        {{ user.user.school.contact.state }} -
                        {{ user.user.school.contact.pincode }}
                      </p>
                      <p class="mb-0">
                        Reg. No.:
                        <span>{{ user.user.school.registration_no }}</span>
                      </p>
                    </div>
                  </div>
                  <div
                    class="text-center font-weight-bold h4 text-uppercase border-top py-1 mb-0"
                  >
                    ADMIT CARD
                  </div>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-12 col-md-10">
                  <table class="table table-bordered table-sm">
                    <tbody>
                      <tr>
                        <th scope="row">Session</th>
                        <td>{{ examData.session.name }}</td>
                        <th scope="row">Std. Code</th>
                        <td>{{ student.student_code }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Name</th>
                        <td colspan="3" class="font-weight-bold text-uppercase">
                          {{ student.first_name }} {{ student.last_name }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Class</th>
                        <td>{{ examData.school_class.name }}</td>
                        <th scope="row">Roll No.</th>
                        <td>{{ student.enrollment[0].roll_no }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Hall No</th>
                        <td></td>
                        <th scope="row">Exam</th>
                        <td>{{ examData.exam.name }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="col-12">
                  <table class="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th scope="col">Subject</th>
                        <th scope="col">Date</th>
                        <th scope="col">Day</th>
                        <th scope="col">Time</th>
                        <th scope="col">Invigilator's sign</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="examSubject in examData.class_section_exam_subject"
                        :key="examSubject.id"
                      >
                        <td scope="row" class="text-uppercase">
                          {{ examSubject.subject.name }}
                        </td>
                        <td>
                          {{ moment(examSubject.date).format("DD/MM/YYYY") }}
                        </td>
                        <td class="text-uppercase">
                          {{ moment(examSubject.date).format("ddd") }}
                        </td>
                        <td>
                          {{
                            moment(examSubject.start_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )
                          }}
                          -
                          {{
                            moment(examSubject.end_time, "HH:mm:ss").format(
                              "hh:mm A"
                            )
                          }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row justify-content-between mt-2">
                <div class="col-4 text-center">
                  <p class="mt-4 pt-1 border-top font-weight-bold">
                    Date of issue
                  </p>
                </div>
                <div class="col-4 text-center">
                  <p class="mt-4 pt-1 border-top font-weight-bold">Principal</p>
                </div>
              </div>

              <div class="mt-4 py-2 text-center">
                <p>
                  <strong class="mr-2">N.B:</strong>Candidates must show this
                  Admit Card on demand to the Principal or invigilator or any
                  authorized person.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center" v-else>
          <div
            class="col-12 d-flex align-items-center justify-content-center col-md-10 py-5 px-2 text-center bg-light rounded"
            style="min-height:400px;"
          >
            <p class="font-weight-bold">
              Please select a student to view admit card.
            </p>
          </div>
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'IdCardPreview',
  computed: {
    ...mapState(['user']),
  },
  props: ['student', 'examData'],
  data: function() {
    return {
      loading: false,
    }
  },
  methods: {
    moment,
    handleListClick(student) {
      this.selectedStudentId = student.id
      this.selectedStudent = student
      this.$emit('studentSelected', this.selectedStudent)
    },
    print() {
      this.$htmlToPaper('admitCard')
    },
  },
}
</script>
